import { Gradient } from './parseGradientString';

export const generateGradientString = (gradientData: Gradient) => {
  if (!gradientData.gradientType) return 'linear-gradient(90deg, #000000 0%, #00000000 100%)';
  let gradientString = '';

  switch (gradientData.gradientType) {
    case 'linear-gradient':
      gradientString += 'linear-gradient(' + gradientData.gradientDirection;
      break;
    case 'radial-gradient':
      gradientString += 'radial-gradient(circle';
      break;
  }

  gradientData.colorList.forEach((color) => {
    gradientString += `, ${color.color} ${color.stop}%`;
  });
  gradientString += ')';

  return gradientString;
};
